var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TranslatePipe } from '@ngx-translate/core';
import { PrefixedTranslatePipe } from './prefixed-translate.pipe';
var SchoolShiftPipe = /** @class */ (function (_super) {
    __extends(SchoolShiftPipe, _super);
    function SchoolShiftPipe(translatePipe) {
        return _super.call(this, translatePipe, 'SCHOOL_SHIFTS.') || this;
    }
    return SchoolShiftPipe;
}(PrefixedTranslatePipe));
export { SchoolShiftPipe };
